import { Brand } from "@/models/Brands.model";
import { Event } from "@/models/Events.model";
import { Job } from "@/models/Job.model";
import { buildPath, siteRoutes } from "@/routes/siteRoutes";
import {
  AspectRatio,
  Box,
  Card,
  Flex,
  Grid,
  Heading,
  Text,
} from "@radix-ui/themes";
import { FC, JSX } from "react";
import { useNavigate } from "react-router-dom";
import Markdown from "react-markdown";
import DateObject from "react-date-object";
import {
  defaultCountries,
  FlagImage,
  parseCountry,
} from "react-international-phone";
interface JobOverviewListItemProps {
  job: Job;
  brand: Brand;
  event: Event;
}

const JobOverviewListItem: FC<JobOverviewListItemProps> = ({
  job,
  brand,
  event,
}): JSX.Element => {
  const navigate = useNavigate();

  const eventCountry = defaultCountries.find((item) => {
    const parsedCountry = parseCountry(item);
    return parsedCountry?.iso2 === event.country;
  });

  const created = new DateObject(job.created_at.toDate());

  return (
    <Card
      size="2"
      key={job.slug}
      onClick={() => {
        navigate(buildPath(siteRoutes.jobs.view, { slug: job.slug }));
      }}
      style={{
        cursor: "pointer",
      }}
    >
      <Flex gap="3" direction="column">
        <Grid columns={{ initial: "4", lg: "12" }} gap="3">
          <Box gridColumn={{ initial: "1 / 2", lg: "1 / 2" }}>
            <AspectRatio ratio={1 / 1}>
              <img
                src={brand.logoURL}
                alt={`${brand.name} logo`}
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                  borderRadius: "var(--radius-2)",
                }}
              />
            </AspectRatio>
          </Box>
          <Box gridColumn={{ initial: "2 / 5", lg: "2 / 13" }}>
            <Flex align="center">
              <Flex direction="column" gap="2">
                <Box>
                  <Heading as="h3" size="4" mb="0">
                    {job.position}
                  </Heading>
                  <Text size="2" as="div">
                    {brand.name}
                  </Text>
                </Box>
                <Box>
                  <Text size="2" as="div" color="gray">
                    {eventCountry && (
                      <Flex gap="2" align="center">
                        <FlagImage iso2={eventCountry[1]} />
                        <Text size="2" as="span" color="gray">
                          {eventCountry[0]}
                        </Text>
                      </Flex>
                    )}
                  </Text>
                </Box>
              </Flex>
            </Flex>
          </Box>
          <Box gridColumn={"1 / -1"}>
            <Text align={{ initial: "left", md: "right" }} size="1" as="div">
              Posted {created.format("DD.MM.YYYY")}
            </Text>
          </Box>
        </Grid>
        <Box>
          <Markdown>{job.descriptions.role}</Markdown>
        </Box>
      </Flex>
    </Card>
  );
};

export default JobOverviewListItem;
